/**
 * @desc 导出库位库存箱规
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stockPool.exportStockBox.Params, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/exportStockBox`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
